import { Navigate } from "react-router-dom";
import MatxLayout from "./components/MatxLayout/MatxLayout";

// Session pages:
import NotFound from "./views/sessions/NotFound";

// Componentes:
import Dashboard from "./views/inicio/Dashboard";
import PersonaFisicaTable from "./project/components/PersonaFisica/PersonaFisicaTable";
import PersonaFisica from "./project/components/PersonaFisica/PersonaFisica";
import PersonaFisicaHistorialTable from "./project/components/PersonaFisicaHistorial/PersonaFisicaHistorialTable";
import PersonaJuridicaTable from "./project/components/PersonaJuridica/PersonaJuridicaTable";
import PersonaJuridicaHistorialTable from "./project/components/PersonaJuridicaHistorial/PersonaJuridicaHistorialTable";
import PersonaFisicaHistorial from "./project/components/PersonaFisicaHistorial/PersonaFisicaHistorial";
import PersonaJuridica from "./project/components/PersonaJuridica/PersonaJuridica";
import PersonaJuridicaHistorial from "./project/components/PersonaJuridicaHistorial/PersonaJuridicaHistorial";




const routes = [
  {
    element: (
      <MatxLayout />
    ),
    children: [
      //{ path: "/inicio", element: <Expedientes /> },
      { path: "/personas/inicio", element: <Dashboard /> },
      { path: "/personas/persona-fisica-table", element: <PersonaFisicaTable /> },
      { path: "/personas/persona-fisica/:id/:action", element: <PersonaFisica /> },
      { path: "/personas/persona-fisica/:new", element: <PersonaFisica /> },

      { path: "/personas/persona-fisica-historial-table", element: <PersonaFisicaHistorialTable /> },
      { path: "/personas/persona-fisica-historial/:id/:action", element: <PersonaFisicaHistorial /> },
      
      { path: "/personas/persona-juridica-table", element: <PersonaJuridicaTable /> },
      { path: "/personas/persona-juridica/:id/:action", element: <PersonaJuridica /> },
      { path: "/personas/persona-juridica-historial-table", element: <PersonaJuridicaHistorialTable /> },
      { path: "/personas/persona-juridica-historial/:id/:action", element: <PersonaJuridicaHistorial /> },

      ]
  },

  // session pages route
  { path: "/session/404", element: <NotFound /> },
  { path: "/", element: <Navigate to="personas/inicio" /> },
  { path: "*", element: <Navigate to="personas/inicio" /> }
];

export default routes;
